import { ModuleCompletionStatusEnum } from '../enums/module-completion-status.enum';
import { ModuleCompletionStatus } from './module-completion-status.model';

// @dynamic
export class ModuleCompletitionStatuses {
    static all: ModuleCompletionStatus[] = [
        {
            id: null,
            name: '',
            translationLabel: 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.ALL',
            color: '#A6A6A6',
            selected: false,
        },
        {
            id: ModuleCompletionStatusEnum.NOT_STARTED,
            name: ModuleCompletionStatusEnum.NOT_STARTED,
            translationLabel: 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.NOT_STARTED',
            color: '#FFE604',
            selected: false,
        },
        {
            id: ModuleCompletionStatusEnum.IN_PROGRESS,
            name: ModuleCompletionStatusEnum.IN_PROGRESS,
            translationLabel: 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.IN_PROGRESS',
            color: '#3774EF',
            selected: false,
        },
        {
            id: ModuleCompletionStatusEnum.COMPLETED,
            name: ModuleCompletionStatusEnum.COMPLETED,
            translationLabel: 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.COMPLETED',
            color: '#B1D42D',
            selected: false,
        },
    ];
}
